module.exports = __webpack_public_path__ + "img/faq.c221a6fb.svg";